import CopyButton from "@/components/CopyButton";
import { Box, colors, Stack, styled, useTheme } from "@mui/material";

const StyledWrapper = styled(Stack)(({theme}) => ({
  '.label': {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  '.value': {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.primary,
  }
}))

function LabelValue({ label, value, copyEnable }) {
  return (
    <StyledWrapper direction="column" spacing={1}>
      <div className="label">{label}</div>
      <Stack direction={"row"} spacing={1} alignItems={'center'}>
        <div className="value">{value}</div>
        {copyEnable && <CopyButton value={value} />}
      </Stack>
    </StyledWrapper>
  );
}

export default LabelValue;
